import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal" style={{ maxWidth: 420 }} onClick={(e) => e.stopPropagation()}>
        <div style={{ padding: '24px 24px 8px' }}>
          <div
            style={{
              width: 44,
              height: 44,
              borderRadius: '50%',
              background: danger ? 'var(--color-danger-soft)' : 'var(--color-warning-soft)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 14,
            }}
          >
            <AlertTriangle size={22} color={danger ? 'var(--color-danger)' : 'var(--color-warning)'} />
          </div>
          <h3 style={{ margin: '0 0 8px', fontSize: 17 }}>{title}</h3>
          <p style={{ margin: 0, fontSize: 14, color: 'var(--color-ink-soft)', lineHeight: 1.5 }}>{message}</p>
        </div>
        <div style={{ display: 'flex', gap: 10, padding: 20, justifyContent: 'flex-end' }}>
          <button className="btn btn-outline" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button className={`btn ${danger ? 'btn-danger' : 'btn-primary'}`} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
